module.exports = __webpack_public_path__ + "img/8400.6071a6b8.jpg";